import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import {CloseMessageAction} from "./actions";

import './custom_toast.scss';

export default function () {
    const dispatch = useDispatch();
    const toasts = useSelector(state => state.toasts ?? []);

    return (
        <div id='mindsets-toasts-box'>{
            toasts.map(toast => {
                return (
                    <div
                        className={'mindsets-toast ' + toast.severity}
                        key={toast.id}
                    >
                        <span dangerouslySetInnerHTML={{__html: toast.body}}/>
                        <span>
                            <button
                                className="close-toast"
                                onClick={() => dispatch(CloseMessageAction(toast.id))}>
                                <i className="fa fa-times"/>
                            </button>
                        </span>
                    </div>
                );
            })
        }</div>
    );
}
